export default __webpack_public_path__ + "static/media/Forward.0723d24d.svg";